import QdtComponents from './QdtComponents';

export default QdtComponents;
